<template>
  <div
    v-if="checkIfShows"
    id="drawer"
    ref="drawer"
    :class="[className, { 'opened': show }]"
  >
    <slot />
  </div>
</template>

<script>
  import { throttle } from '@Foundation/utilities';
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import { HEADER_MOBILE } from '@Foundation/constants/headermobile';
  export default {
    name: 'Drawer',
    props: {
      className: { type: String, required: false, default: 'header__aside' }
    },
    data() {
      return {
        show: false,
        DOMhidden: true,
        smallScreen: !window.matchMedia(`(min-width: ${HEADER_MOBILE}px)`).matches,
        closeButton: null,
        lastButton: null
      };
    },
    computed: {
      checkIfShows() {
        return this.smallScreen ? !this.DOMhidden : true;
      }
    },
    mounted() {
      eventBus.$on('toggle-drawer', this.toggle);
      this.closeButton = document.querySelector('.header__banner__mobile > button');

      /* istanbul ignore next */
      window.addEventListener('resize', throttle(() => {
        this.smallScreen = !window.matchMedia(`(min-width: ${HEADER_MOBILE}px)`).matches;
      }, 100));
    },
    methods: {
      toggleEvents(status) {
        if (status) {
          this.addEvents();
        } else {
          this.removeEvents();
        }
      },
      addEvents() {
        this.lastButton = this.$refs.drawer.querySelectorAll('a, button')[this.$refs.drawer.querySelectorAll('a, button').length - 1];

        if (!this.smallScreen) {
          return;
        }
        window.addEventListener('keydown', this.keydownEvent);
      },
      removeEvents() {
        window.removeEventListener('keydown', this.keydownEvent);
      },
      keydownEvent($event) {
        const tab = $event.keyCode === 9;
        const shiftTab = $event.shiftKey && $event.keyCode === 9;

        if (!tab) {
          return;
        }

        if (!shiftTab && this.lastButton === document.activeElement) {
          $event.preventDefault();
          this.focusOnCloseButton();
        }

        if (shiftTab && this.closeButton === document.activeElement) {
          $event.preventDefault();
          this.focusOnLastButton();
        }
      },
      focusOnCloseButton() {
        this.closeButton.focus();
      },
      focusOnLastButton() {
        this.lastButton.focus();
      },
      toggle(status) {
        if (status) {
          this.DOMhidden = false;
          setTimeout(() => {
            this.show = true;
            this.toggleEvents(true);
          }, 10);
          document.body.classList.add('body-hide-overflow');
        } else {
          this.show = false;
          this.toggleEvents(false);
          setTimeout(() => {
            this.DOMhidden = true;
          }, 500);
          document.body.classList.remove('body-hide-overflow');
        }
      }
    }
  };
</script>
